module.exports = __webpack_public_path__ + "img/pci.8dc2bf8b.png";